var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-instant-search-ssr',{staticClass:"nuxt-ssr-instantsearch"},[_c('ais-configure',{attrs:{"hitsPerPage":_vm.hitsPerPage,"filters":_vm.filters}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }